define.alias("shared/components/shared/post/secondary/hashtag-suggestions/tabs", "preview-grid/components/shared/post/secondary/hashtag-suggestions/tabs");